import { UiCategoryEnum } from "../types"
const {
  BULK_ACTIONS,
  DISCIPLINE,
  DISCIPLINE_ALL,
  DISCIPLINE_REPORT,
  EXPORT,
  EXPORT_DOC_VALIDITY_DATA,
  EXPORT_DOCS,
  EXPORT_EMPLOYEE_CARDS,
  EXPORT_PROFILES,
  IMPORT,
  REPORTING,
  FILES_AND_PERFORMANCE_DATA_IMPORTS,
  PROFILE_IMPORTS,
  UNDER_PERFORMANCE,
  TERMINATE,
  INTEGRATIONS,
  ADAGIN,
  AGRIGISTICS,
  PAYSPACE,
  MODERN_API,
  ADAGIN_SYNC,
  AGRIGISTICS_SYNC,
  PAYSPACE_SYNC,
  MODERN_API_SYNC,
  ADAGIN_LOGS,
  AGRIGISTICS_LOGS,
  PAYSPACE_LOGS,
  ADAGIN_SOURCE_FILES,
  AGRIGISTICS_SOURCE_FILES,
  PAYSPACE_SOURCE_FILES,
} = UiCategoryEnum

export const navButtonsWithCustomActions: string[] = [
  ADAGIN_SOURCE_FILES,
  AGRIGISTICS_SOURCE_FILES,
  PAYSPACE_SOURCE_FILES,
  BULK_ACTIONS,
  DISCIPLINE,
  DISCIPLINE_ALL,
  DISCIPLINE_REPORT,
  UNDER_PERFORMANCE,
  EXPORT,
  IMPORT,
  EXPORT_DOC_VALIDITY_DATA,
  EXPORT_DOCS,
  EXPORT_EMPLOYEE_CARDS,
  EXPORT_PROFILES,
  REPORTING,
  FILES_AND_PERFORMANCE_DATA_IMPORTS,
  PROFILE_IMPORTS,
  TERMINATE,
  INTEGRATIONS,
  ADAGIN,
  AGRIGISTICS,
  PAYSPACE,
  MODERN_API,
  ADAGIN_SYNC,
  AGRIGISTICS_SYNC,
  PAYSPACE_SYNC,
  MODERN_API_SYNC,
  ADAGIN_LOGS,
  AGRIGISTICS_LOGS,
  PAYSPACE_LOGS,
]
